export default function createProfile(element: HTMLElement) {
	Promise.all([import('react'), import('react-dom'), import('./profile')]).then(
		([React, ReactDOM, { default: Profile }]) => {
			ReactDOM.render(<Profile />, element);
		},
	);
}
